import script from "./show-data.vue?vue&type=script&setup=true&lang=js"
export * from "./show-data.vue?vue&type=script&setup=true&lang=js"

import "./show-data.vue?vue&type=style&index=0&id=30cd4af3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30cd4af3"]])

export default __exports__